import React from 'react';
import { TextField } from '@mui/material';
import useChangeEvent from '@dyl/hooks/useChangeEvent';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';

/**
 * @typedef Props
 * @property {string | string[]} path
 */

/**
 * @param {Props & import('@mui/material').TextFieldProps} props
 */
export default function SimpleTaskField({
    path,
    helperText = ' ',
    error: propsError,
    limit = Number.MAX_SAFE_INTEGER,
    ...other
}) {
    const [value, setValue, error] = useTaskField(path);
    const onChange = useChangeEvent(setValue, { transform: (val) => val.substring(0, limit) });

    return (
        <TextField
            value={value}
            onChange={onChange}
            error={!!error || !!propsError}
            helperText={error || helperText}
            variant='filled'
            fullWidth
            {...other}
        />
    );
}